import { render, staticRenderFns } from "./RequestDetails.vue?vue&type=template&id=451329d3&scoped=true"
import script from "./RequestDetails.ts?vue&type=script&lang=ts&external"
export * from "./RequestDetails.ts?vue&type=script&lang=ts&external"
import style0 from "./RequestDetails.scss?vue&type=style&index=0&id=451329d3&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451329d3",
  null
  
)

export default component.exports